import React, { Fragment, useState, useEffect, useRef } from 'react';


import { format, set } from 'date-fns';
import { Button, Dropdown } from 'react-bootstrap';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import "./ordersTable.css";
const { config } = require('../api/api');


const MyordersTable = ({ VendorKey, Payload }) => {
  const base_url = config.baseURL;
  const redirectURL = config.redirectURL;
  const { t } = useTranslation();


  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  // const handleClose = () => setShow(false);

  const [odata, setOdata] = useState([]);
  const [orddata, setOrddata] = useState([]);
  const [selectedOption, setSelectedOption] = useState('Visa Orders');
  const [filter,setFilter]=useState('success');


  const handleClose = () => {
    setShow(false);
  };


 const lnstr = Cookies.get("langData") ? Cookies.get("langData") : "en";

  const [profile, setProfile] = useState(null);
  const [error, setError] = useState(null);


  const [totalEarnings, setTotalEarnings] = useState('');
  const [insuranceData, setInsuranceData] = useState([]);
  const [currentItems, currentItemsdata]= useState([]);
  const [totalPages, totalPagess]=useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Number of items per page
  const [indexOfFirstItem, setindexOfFirstItem]= useState(0);
  const [indexOfLastItem, setIndexOfLastItem]= useState(0);

  const [iframeUrl, setIframeUrl] = useState("");
  const [showIframe, setShowIframe] = useState(false);
  const [iframeUrl1, setIframeUrl1] = useState("");
  const tableRef=useRef(null);
  const [pageChanged,setPageChanged]=useState(false);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [iframeUrl2, setIframeUrl2] = useState("");
  const [applicationId, setApplicationId] = useState(null);
  const openIframe = (url) => {
    setIframeUrl(url);
    setShowIframe(true);
  };

  const closeIframe = () => {
    setIframeUrl("");
    setShowIframe(false);
  };

  const handleIframe = async (visaObj) => {
    debugger;
    const mailvalue = visaObj.email;
    const application_status= visaObj.application_status;
    const postvData1 = { email: mailvalue };
  
    // Check if VendorKey is truthy (not null, undefined, or empty string)
    if (VendorKey) {
      try {
        setIframeLoaded(false);
        setLoading(true);
        const response = await fetch(base_url + '/visaorderlist', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${VendorKey}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(postvData1),
        });
  
        // Check if the response was successful
          if (response.ok) {
          const data = await response.json();
          const parse_application = JSON.parse(visaObj?.applications);
          const deeplink=data?.result?.deeplink;
            setIframeUrl1(data?.result?.deeplink)
          // setIframeUrl1({
          //   deeplink: deeplink.includes("?iframe=true")?deeplink : deeplink.includes("?") ? deeplink + "&iframe=true" : deeplink + "?iframe=true",
          //   application_status: application_status,
          //   applicationId: parse_application?.[0]?.id
          // });
          
          setShowIframe(true);
          // Handle the response data here

          console.log('Response:', data);
        } else {
          console.error('Error: Failed to fetch data, Status:', response.status);
        }
      } catch (error) {
        console.error('Error:', error);  // This handles any errors during the fetch request
      }
      finally { 
        setLoading(false);
      }
    } else {
      console.error('Error: VendorKey is missing or invalid');
    }
  };
  


  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden'; 
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = 'auto'; 
    };
  }, [show]);

  useEffect(() => {
    if (showIframe) {
      document.body.style.overflow = 'hidden'; 
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = 'auto'; 
    };
  }, [showIframe]);



  const handleStatus = async (e) => {
    debugger;
    const frmData = new FormData();
    frmData.append('order_id', e.target.value);
    frmData.append('vendor_key', VendorKey);
    // console.log(frmData)
    try {
      // debugger
      const response = await axios.post(base_url+'/each_order_details', frmData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      // console.log('Image upload successful:', response.data);
      var order_details = response.data.result.order.applications;
      if (order_details[0] == '[') {
        var orders = JSON.parse(order_details);
        order_details = orders[0];
      } else {
        order_details = order_details[0];
      }
      // order_details = order_details[0] == '['?JSON.parse(order_details):order_details[0];
      // setOdata(response.data.result.order.applications[0]);
      // setOdata(order_details);
      setOdata(response.data.result.order);
      setOrddata(response.data.result.order.order_id);
      setShow(true);
    } catch (error) {
      console.error('Error uploading image:', error);
      // Handle error, show error message, etc.
    }
  };


 const calculatePagination = (page,list) => {
    debugger
    const indexOfLastItem = page * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    setIndexOfLastItem(indexOfLastItem);
    setindexOfFirstItem(indexOfFirstItem);
    const currentItem = list.slice(indexOfFirstItem, indexOfLastItem);
    currentItemsdata(currentItem);
  };
  
  const handleNextPage = () => {
    debugger
    setCurrentPage((prevPage) => {
      const newPage = prevPage < totalPages ? prevPage + 1 : prevPage;
      if(profile.length > 0){
        calculatePagination(newPage,profile);
      }
      return newPage;
    });
  };
  
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => {
      const newPage = prevPage > 1 ? prevPage - 1 : prevPage;
      if(profile.length > 0){
        calculatePagination(newPage,profile);
      }
      // calculatePagination(newPage,insuranceData);
      return newPage;
    });
  };


  const getButtonClass = (page) =>
    `btn btn-link w-100   text-decoration-none ${
      filter === page ? "btn btn-primary text-light" : "text-dark"
    }`;

  useEffect(()=>{

    if(pageChanged && tableRef.current){
  tableRef.current.scrollIntoView({ behavior: "smooth"});
      }
      else{
        console.log("element not found");
      }
      return ()=>{
        setPageChanged(false);
      }
  },[pageChanged]);

  const getVisaOrders = async () => {
       setLoading(true);
       setCurrentPage(1);
        var get_order_url = base_url+"/visa_order_list";
        
        debugger
        fetch(get_order_url, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${VendorKey}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(Payload),
        })
          .then(response => response.json())
          .then(data => {
            debugger
          // const testData = Array(15).fill(data.result[0]);
          // data.result = testData;
          if(filter==="success"){
            setLoading(false);
            const filterSuccess = data.result.filter(item => item.superjet_payment_status.toLowerCase() === 'success' );
            setProfile(filterSuccess);
             // Set total pages based on data length
        const totalPagesCount = Math.ceil(filterSuccess.length / itemsPerPage);
        totalPagess(totalPagesCount);

        // Initial page calculation
        calculatePagination(1,filterSuccess);
          }
          else if(filter==="pending"){
             setLoading(false);
            const filterPending = data.result.filter(item => item.superjet_payment_status.toLowerCase() !== 'success' && item.application_status.toLowerCase() === 'success' && item.is_deleted === "no" );
            setProfile(filterPending);
             // Set total pages based on data length
        const totalPagesCount = Math.ceil(filterPending.length / itemsPerPage);
        totalPagess(totalPagesCount);

        // Initial page calculation
        calculatePagination(1,filterPending);
          }
          })
          .catch(error => {
            console.error('Error fetching countries:', error);
          });
        }
  
  useEffect(() => {

      // const location  = new URL(window.location.href);
      // const staffid = location.searchParams.get('staff_id');


      //   var vkData = { token: usrtok, user_type: "agent", staff_id: staffid };
      if(VendorKey){
           getVisaOrders();
        }
    }, [ VendorKey,Payload,filter]);


  const handleRemove = async(e,order_id) => {
    e.preventDefault();
    debugger;
    setLoading(true);
     fetch(base_url+"/evisa_order_cancel",{
          method:"POST",
          headers:{
            "Authorization":"Bearer "+VendorKey,
            "Content-Type":"application/json"
          },
          body:JSON.stringify({order_id:order_id})
        }).then((response)=>response.json())
        .then((data)=>{
          if(data.message==="success"){
            //  setFilter("pending");
             getVisaOrders();
          }
        }).catch(err=>console.error("while updating application status err : "+err))
        .finally(() => {
          setLoading(false);
        });
  }

const handlePayment = (e,order_id) => {
  e.preventDefault();
  debugger;
  window.location.href = redirectURL + '/visa-payment?order_id=' + order_id;
}


  return (
    <div>


      <div className="features_section my-1">
         <div className="container">

                <div className="row  d-flex justify-content-end">
           
                
                <div className="col-lg-4 col-md-6 pt-5 ">
                  <div className="w-100 orders-table">    
                <ul className={`list-unstyled mb-0 p-0 d-flex justify-content-end ${lnstr=="ar"?"mr-3":"ml-3"}`}>
                  <li  style={{ 
                    // flex: "1 1 0", /* grow, shrink, basis */
          textAlign: "center",
          border: "1px solid #ccc",
          // borderTopLeftRadius:"5px",
          // borderBottomLeftRadius:"5px",
         backgroundColor:filter==="success"?"#3fd2f2":"",
          //  borderRadius:"20px 0px 0px 20px"
          }}>
                    <button
                      className={getButtonClass("success")}
                      style={{ fontSize: "18px",textAlign:"center",  borderRadius:"20px 0px 0px 20px" }}
                      onClick={(e) => {e.preventDefault(); setFilter("success")}}
                    >
                      {t("Success")}
                    </button>
                  </li>
                  <li   style={{
                    //  flex: "1 1 0", /* grow, shrink, basis */
          textAlign: "center",
          border: "1px solid #ccc",
          backgroundColor:filter==="pending"?"#3fd2f2":"",
          // borderRadius:"0px 20px 20px 0px"
         }}>
                    <button
                      className={getButtonClass("pending")}
                      style={{ fontSize: "18px" ,textAlign:"center",  borderRadius:"0px 20px 20px 0px"}}
                      onClick={(e) => {e.preventDefault();  setFilter("pending")}}
                    >
                      {t("Pending")}
                    </button>
                  </li>
                </ul>
                </div>
        
               
             
        </div>
        </div>
          <div className="row g-4 justify-content-center">

            <div className="col-12 wow fadeInUp" data-wow-delay="0.2s" style={{ overflowX: 'auto' }}>
              {/* { userData != null && userData != undefined && userData.agency_name != null && userData.agency_name != undefined ?

              <div className='row'>
                <div className='col-6'><b style={{ textTransform: 'uppercase', fontSize: 17 }}>{userData.agency_name != null && userData.agency_name != undefined ? userData.agency_name: <span>{userData.first_name} {userData.last_name}</span>}</b></div>
                
              </div> : <></>

               } */}

              {
                <div className="orders-table" ref={tableRef}>
         
                
                  <table  className='table table-bordered mt-3'>
                    <thead ><tr><th rowSpan={2} >#</th>
                     <th rowSpan={2}>{t('Date of Application')}</th>
                     <th rowSpan={2}>{t('Order')} {t('ID')}</th> 
                     {/* {<th>{t('User')} {t('ID')}</th>}  */}
                      <th colSpan={2} style={{ textAlign:'center' }}>{t('Travel')}</th>
                      
                      
                     {filter==="success" && <th rowSpan={2}>{t("Check")} {t("Status")}</th>}
                      { <th rowSpan={2}>{t('View')}</th>}
                      {filter!=="success" && <th rowSpan={2} colSpan={2} style={{textAlign:"center"}}>{t('Action')}</th>}

                      </tr>
                      
                      <tr><th style={{ width: '15%' }}>{t('From')}</th>
                      <th style={{ width: '15%' }}>{t('To')}</th></tr>

                      </thead>
                    <tbody>

                      {(currentItems?.length === 0) ? <tr><td colSpan={7} className='text-center'>{t('No')} {t('Records')} {t('Found')}</td></tr> : ''}
                      {currentItems?.map((prof, index) => {
                        const traveller_details = JSON.parse(prof.traveller); // Assuming this is needed elsewhere, but it's not used here.
                        return (
                          <tr key={index}>
                            <td>{indexOfFirstItem+index + 1}</td>
                            <td>{format(new Date(prof.created_at), 'dd/MM/yyyy')}</td>
                            <td>{prof.order_id}</td>
                            {/* <td>{t(traveller_details?.id)}</td> */}
                            <td>{t(prof.arrival)}</td>
                            <td>{t(prof.destination)}</td>
                            {/* {userData != null && userData != undefined && userData.agency_name != null && userData.agency_name != undefined ? <td></td>:  <td>{prof.fee} ({prof.currency})</td>} */}
                            {/* <td>{prof.earnings} ({prof.currency})</td> */}
                           { filter === "success" && 
                           <>
                           <td>
                            {/* Download Button */}
                            
                            {/* Download Button */}
                            <button
                              onClick={() => handleIframe(prof)}
                               className="btn btn-primary rounded-pill text-white py-1 px-2"
                              // onClick={() => openIframe(`https://superjet.simplevisa.net/travellers/deeplinks/sign_in/FQ6RtrhUmQgeZwHClSPGopP7l8x8djBAWQIIdrO13FM`)}
                              style={{ background: "none", border: "none", cursor: "pointer" }}
                            >
                              {t("Check")} {t("Status")}
                            </button>
                       
                          </td>
                           
                            </>}
                             <td>
                              <Button
                                variant="primary"
                                style={{ fontWeight: 'normal' }}
                                className="btn btn-primary rounded-pill text-white py-1 px-2"
                                onClick={handleStatus}
                                value={prof.order_id}
                              >
                              {t('View')}
                              </Button>
                            </td>
                                { filter !== "success" && 
                           <>
                           <td>
                            {/* Download Button */}
                            
                            {/* Download Button */}
                            <button
                              onClick={(e) => handlePayment(e,prof.order_id)}
                               className="btn btn-primary rounded-pill text-white py-1 px-2"
                              // onClick={() => openIframe(`https://superjet.simplevisa.net/travellers/deeplinks/sign_in/FQ6RtrhUmQgeZwHClSPGopP7l8x8djBAWQIIdrO13FM`)}
                              style={{ background: "none", border: "none", cursor: "pointer" }}
                            >
                              {t("Pay")}
                            </button>
                       
                          </td>
                            <td>
                              <Button
                                variant="primary"
                                style={{ fontWeight: 'normal' }}
                                className="btn btn-primary rounded-pill text-white py-1 px-2"
                                onClick={(e) => handleRemove(e, prof.order_id)}
                              >
                              {t('Cancel')}
                              </Button>
                            </td>
                            </>}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table> 
                </div>
              }
              {totalPages === 0 ? <div></div> : <div className="pagination-controls-new">
                <button onClick={handlePrevPage} disabled={currentPage === 1}>
                  ‹
                </button>
                <span>

                </span>
                <span>
                  {t('Page')} {currentPage} {t('of')} {totalPages}
                </span>
                <span>

                </span>
                <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                  ›
                </button>
              </div>}
              {/* {userData != null && userData != undefined && userData.agency_name != null && userData.agency_name != undefined && <h3 style={{textAlign:"right"}}>{t('Total')} {t('Earnings')} :  {totalEarnings}</h3>} */}
            </div>
          </div>
        </div>
      </div>
      


      {/* <Footer /> */}
        {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}



      {/* {showIframe && (
        <div className='modal'>
          <div className = 'modal-content'style={{height: "600px" }}>
            <h2>{t("Download")}</h2>
            <button type="button" className="close" onClick={closeIframe}>
          &times; 
        </button>
        <div>

        {( iframeUrl1) && 
        <><iframe
                src={iframeUrl1}
            style={{ width: "100%", height: "500px", border: "none" }}
            title="API Content"
            
          ></iframe>
          </>}
        </div>
          </div>
        </div>
      )} */}
      {showIframe && (
        <div className='modal'>
          <div
            className='modal-content'
            style={{
              height: "600px",
              width: "90%",          // increased width
              maxWidth: "1200px",    // optional
            }}
          >
            <h2>{t("Download")}</h2>

            <button type="button" className="close" onClick={closeIframe}>
              &times;
            </button>

            <div>
              {iframeUrl1 && (
                <>
                  <iframe
                    src={iframeUrl1}
                    style={{ width: "100%", height: "500px", border: "none" }}
                    title="API Content"
                  ></iframe>
                </>
              )}
            </div>
          </div>
        </div>
      )}


      {show && (
        <div className='modal'>
          <div className='modal-content' style={{height: "550px" , width:'700px'}}>
          <h2><span>{t('Order')} {t('Status')}</span></h2>
          <button type="button" className="close" onClick={handleClose}>
          &times;
          </button>
          <div style={{height:'50px'}}></div>
          <div>

            <table style={{ width:'250'}}>
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Order')} {t('ID')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{textAlign:'left'}}><b>{orddata}</b></td></tr>


            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Status')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.order_status != null && odata?.order_status != undefined ? odata?.order_status : ""}</b></td></tr>


            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('First Name')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.first_name != null && odata?.first_name != undefined ? odata?.first_name : ''}</b></td></tr>

            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Last Name')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left'}}><b>{odata?.last_name != null && odata?.last_name != undefined ? odata?.last_name : ''}</b></td></tr>
            {/* <tr><td style={{ fontWeight: 'bold' }}>{t('DOB')}</td><td style={{ paddingLeft: 10, paddingRight: 10 }}>:</td><td style={{ textTransform: 'capitalize' }}><b>{odata?.dob != null && odata?.dob != undefined ? odata?.dob.split('T')[0] : ''}</b></td></tr> */}
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Email')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{textAlign:'left'}}><b>{odata?.email != null && odata?.email != undefined ? odata.email : ''}</b></td></tr>
            {/* <tr><td style={{ fontWeight: 'bold' }}>{t('Phone')}</td><td style={{ paddingLeft: 10, paddingRight: 10 }}>:</td><td style={{ textTransform: 'capitalize' }}><b>{odata?.phone_p != null && odata?.phone_p != undefined ? odata?.phone_p : ''}</b></td></tr>
            <tr><td style={{ fontWeight: 'bold' }}>{t('Sex')}</td><td style={{ paddingLeft: 10, paddingRight: 10 }}>:</td><td style={{ textTransform: 'capitalize' }}><b>{odata?.sex != null && odata?.sex != undefined ? odata?.sex : ''}</b></td></tr> */}
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Travel From')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.arrival != null && odata?.arrival != undefined ? odata?.arrival : ''}</b></td></tr>

            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Travel To')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.destination != null && odata?.destination != undefined ? odata?.destination : ''}</b></td></tr>

            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Fee')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.fee != null && odata?.fee != undefined ? odata?.fee : ''}</b></td></tr>

            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Currency')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.currency != null && odata?.currency != undefined ? odata?.currency : ''}</b></td></tr>

            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Fee')}&nbsp;{`(OMR)`}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.fee_omr != null && odata?.fee_omr != undefined ? odata?.fee_omr+" OMR" : ''}</b></td></tr>

            <tr><td style={{ fontWeight: 'bold', textAlign:'left'  }}>{t('Payment Status')}</td><td style={{paddingRight: 10  , fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.superjet_payment_status !=null && odata?.superjet_payment_status != undefined ?odata?.superjet_payment_status:''}</b></td></tr>

            <tr><td style={{ fontWeight: 'bold', textAlign:'left'  }}>{t('Date of Application')}</td><td style={{paddingRight: 10  , fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.visa_created != null && odata?.visa_created != undefined ? odata?.visa_created.split('T')[0] : ''}</b></td></tr>
          </table>
          <button type="button"   class="btn btn-sm btn-close d-none d-md-inline-block" aria-label="Close" onClick={handleClose}>{t("Close")}</button>

          </div>
          </div>
        </div>
      )}





     

     </div>
  );
};

export default MyordersTable;